<template lang="pug">
.v-favorite-action.favorite-action(:class="{'active': favoriteCountByItem, 'disabled': disabled}")
	button.favorite-action__btn(
			type="button"
			:disabled="disabled"
			:class="{'active': favoriteCountByItem}"
			@click="toggleFavoriteCount"
			aria-label="Добавить в избранное")
		v-svg-icon.favorite-action__btn-icon(:icon="favoriteCountByItem ? favorite.true?.icon : favorite.false?.icon")
		span.favorite-action__btn-text(v-if="favorite.true?.text || favorite.false?.tex" ) {{ favoriteCountByItem ? favorite.true?.text : favorite.false?.text }}
</template>

<script>
import { mapActions } from 'vuex';
export default {
	props: {
		id: {
			type: [String, Number],
			default: null
		},

		name: {
			type: String,
			default: null
		},

		model: {
			type: String,
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		},

		favorite: {
			type: Object,
			default: {}
		}
	},

	data() {
		return {
			localCount: 0
		};
	},

	computed: {
		favoriteCountByItem() {
			return this.$store.getters['favorite/favoriteCountByItem'](this.id);
		}
	},
	//
	// watch: {
	// 	favoriteCountByItem() {
	// 		this.localCount = this.favoriteCountByItem;
	// 	}
	// },

	created() {
		this.localCount = this.favoriteCountByItem;
	},

	methods: {
		...mapActions({
			add: 'favorite/add',
			remove: 'favorite/remove',
		}),

		toggleFavoriteCount() {
			if (this.favoriteCountByItem) {
				this.remove({
					id: this.id
				});
			} else {
				this.add({
					id: this.id,
					name: this.name
				});
			}
		}
	}
};
</script>